import actionTypes from './actionTypes';

export const setAwaitingFileSelectionTrue = () => ({
  type: actionTypes.setAwaitingFileSelection,
  value: true,
});

export const setAwaitingFileSelectionFalse = () => ({
  type: actionTypes.setAwaitingFileSelection,
  value: false,
});

export const setFiles = (filesArray) => {
  return {
    type: actionTypes.setFiles,
    value: filesArray,
  };
};

export const setFieldValue = (fileIndex, fieldIndex, field, value) => {
  return {
    type: actionTypes.setFieldValue,
    payload: {
      fileIndex,
      fieldIndex,
      field,
      value,
    },
  };
};

export const setCopyFieldValue = (copyFrom, copyTo) => {
  return {
    type: actionTypes.setCopyFieldValue,
    payload: {
      copyFrom,
      copyTo,
    },
  };
};

export const updateFileReadyToUploadFlag = (fileIndex) => {
  return {
    type: actionTypes.updateFileReadyToUploadFlag,
    fileIndex: fileIndex,
  };
};

export const updateFileUploadProgress = (fileIndex, percent) => {
  return {
    type: actionTypes.updateFileUploadProgress,
    fileIndex: fileIndex,
    percent: percent,
  };
};

export const abortUpload = (fileIndex, isAbort) => {
  return {
    type: actionTypes.abortUpload,
    fileIndex: fileIndex,
    isAbort: isAbort,
  };
};

export const setUploadInfo = (fileIndex, uploadInfo) => {
  return {
    type: actionTypes.setUploadInfo,
    fileIndex: fileIndex,
    uploadInfo: uploadInfo,
  };
};

export const updateFileStatus = (fileIndex, status) => {
  return {
    type: actionTypes.updateFileStatus,
    fileIndex: fileIndex,
    status: status,
  };
};

export const updateFileError = (fileIndex, error) => {
  return {
    type: actionTypes.updateFileError,
    fileIndex: fileIndex,
    error: error,
  };
};

export const removeFile = (fileIndex) => {
  return {
    type: actionTypes.removeFile,
    fileIndex: fileIndex,
  };
};

export const setCheckedList = (checkedValue) => {
  return {
    type: actionTypes.setCheckedList,
    checkedValue: checkedValue,
  };
};

export const setRetryStatus = (fileIndex, isRetry) => {
  return {
    type: actionTypes.setRetryStatus,
    fileIndex: fileIndex,
    isRetry: isRetry,
  };
};
